var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-lifebuoy-3",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm7.479,6.347L15.307,7.585A5.845,5.845,0,0,0,12.427,4.7l1.237-2.173a8.379,8.379,0,0,1,3.815,3.821ZM10,14.167A4.167,4.167,0,1,1,14.167,10,4.171,4.171,0,0,1,10,14.167ZM6.336,2.527,7.573,4.7A5.853,5.853,0,0,0,4.694,7.586L2.521,6.347A8.375,8.375,0,0,1,6.336,2.527ZM2.521,13.652l2.173-1.237A5.841,5.841,0,0,0,7.573,15.3L6.336,17.473A8.375,8.375,0,0,1,2.521,13.652Zm11.142,3.821L12.427,15.3a5.851,5.851,0,0,0,2.879-2.885l2.173,1.238A8.372,8.372,0,0,1,13.663,17.473Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.18f721be.svg";
export { ForwardRef as ReactComponent };